import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/historico-atendimento`

    return {
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
    }
}